import AppConfig from "./AppConfig";
var AppConfigService = /** @class */ (function () {
    function AppConfigService() {
    }
    /**
     *
     * @param whitelist optional whitelist for valid param names
     * @returns {{}} object whose property is the param name
     */
    AppConfigService.getSearchParams = function () {
        var url = new URL(window.location.href);
        if (this.isSearchModel() || this.isSearchCatalog()) {
            return new URLSearchParams(url.search);
        }
        return {};
    };
    AppConfigService.getSearchKeyword = function () {
        var _a;
        return (_a = new URLSearchParams(window.location.search).get('k')) !== null && _a !== void 0 ? _a : '';
    };
    AppConfigService.isSearchModel = function () {
        return !!window.location.pathname.includes('/s/model');
    };
    AppConfigService.isSearchItem = function () {
        return !!window.location.pathname.includes('/s/item');
    };
    AppConfigService.isSearchCatalog = function () {
        return !!window.location.pathname.includes('/s/catalog');
    };
    AppConfigService.isSearchNews = function () {
        return !!window.location.pathname.includes('/s/news');
    };
    AppConfigService.getServiceType = function () {
        var domain = window.location.hostname;
        var path = window.location.pathname;
        var href = window.location.href;
        var aperzaJpSubdomain = {
            www: {
                serviceType: AppConfig.APERZA_SEARCH,
            },
            ec: {
                serviceType: AppConfig.APERZA_EC,
            },
            news: {
                serviceType: AppConfig.APERZA_NEWS,
            },
            id: {
                serviceType: AppConfig.APERZA_ID,
            },
            account: {
                serviceType: AppConfig.APERZA_ACCOUNT,
            },
            order: {
                serviceType: AppConfig.APERZA_ORDER,
            },
            business: {
                serviceType: AppConfig.APERZA_BIZ,
            },
        };
        var aperzaComSubdomain = {
            www: {
                serviceType: AppConfig.APERZA_SEARCH,
            },
            ec: {
                serviceType: AppConfig.APERZA_EC,
            },
            order: {
                serviceType: AppConfig.APERZA_ORDER,
            },
            business: {
                serviceType: AppConfig.APERZA_BIZ,
            },
            id: {
                serviceType: AppConfig.APERZA_ID,
            },
            account: {
                serviceType: AppConfig.APERZA_ACCOUNT,
            },
            catalog: {
                serviceType: AppConfig.APERZA_CATALOG,
            },
            tv: {
                serviceType: AppConfig.APERZA_TV,
            },
        };
        if (domain) {
            if (domain.endsWith('.aperza.jp')) {
                // eslint-disable-next-line no-restricted-syntax
                for (var subdomain in aperzaJpSubdomain) {
                    if (domain.startsWith(subdomain)) {
                        var domainObject = aperzaJpSubdomain[subdomain];
                        return domainObject.serviceType;
                    }
                }
            }
            else if (domain.endsWith('.aperza.com')) {
                if (domain.startsWith('www')) {
                    if (path.startsWith('/catalog') ||
                        path.startsWith('/catalog/') ||
                        path.startsWith('/feature/') ||
                        path.startsWith('/feature2/') ||
                        path.startsWith('/company/') ||
                        path.startsWith('/trends/') ||
                        path.startsWith('/download/') ||
                        path.startsWith('/product/') ||
                        path.startsWith('/aboutus/')) {
                        return aperzaComSubdomain.catalog.serviceType;
                    }
                    return aperzaComSubdomain.www.serviceType;
                }
                if (domain.startsWith('ec')) {
                    return aperzaComSubdomain.ec.serviceType;
                }
                if (domain.startsWith('order')) {
                    return aperzaComSubdomain.order.serviceType;
                }
                if (domain.startsWith('business')) {
                    return aperzaComSubdomain.business.serviceType;
                }
                if (domain.startsWith('id')) {
                    return aperzaComSubdomain.id.serviceType;
                }
                if (domain.startsWith('account')) {
                    return aperzaComSubdomain.account.serviceType;
                }
                if (domain.startsWith('tv')) {
                    return aperzaComSubdomain.tv.serviceType;
                }
                // for (const subdomain in aperzaComSubdomain) {
                //   if (domain.startsWith(subdomain)) {
                //     return aperzaComSubdomain[subdomain].serviceType;
                //   }
                // }
            }
            else if (href.includes('neca.') || href.includes('neca-')) {
                return AppConfig.APERZA_NECA;
            }
        }
        return undefined;
    };
    return AppConfigService;
}());
export default AppConfigService;
